import { Injectable } from '@angular/core';
import { ToasterService } from 'angular2-toaster';
import { TranslateService } from 'ng2-translate';

@Injectable()
export class NotificationService {

    constructor(private translateService: TranslateService, private toasterService: ToasterService) {
    }

    showError(titleKey: string, messageKey: string, interpolateParams?: Object) {
        this.toasterService.pop('error', this.getTranslation(titleKey, interpolateParams), this.getTranslation(messageKey, interpolateParams));
    }

    showSuccess(titleKey: string, messageKey: string, interpolateParams?: Object) {
        this.toasterService.pop('success', this.getTranslation(titleKey, interpolateParams), this.getTranslation(messageKey, interpolateParams));
    }

    showWarning(titleKey: string, messageKey: string, interpolateParams?: Object) {
        this.toasterService.pop('warning', this.getTranslation(titleKey, interpolateParams), this.getTranslation(messageKey, interpolateParams));
    }

    handleGlobalErrors(e: any) {
        console.log('handleGlobalErrors - HttpStatusCode:' + e.status);
        let interpolateParams = {};
        if (e._body != null && e.status != 0) {
            interpolateParams = {
                messageInterpolateValue1: JSON.parse(e._body).messageInterpolateValue1,
                messageInterpolateValue2: JSON.parse(e._body).messageInterpolateValue2,
                messageInterpolateValue3: JSON.parse(e._body).messageInterpolateValue3
            };
        }

        switch (e.status) {
            case 417:
                if (e._body != null) {
                    this.showWarning('app.notification.WARNING', JSON.parse(e._body).message, interpolateParams);
                    return;
                }

                this.showError('app.notification.ERROR', 'app.notification.UNEXPECTED_ERROR');
                break;
            case 0:
                this.showError('app.notification.ERROR', 'app.notification.API_GONE_AWAY');
                break;
            default:
                // speziell für den Login, da hier ein anderer Context zurück kommt  
                if (e._body != null) {
                    if (JSON.parse(e._body).error_description != null) {
                        this.showError('app.notification.ERROR', JSON.parse(e._body).error_description, interpolateParams);
                        return;
                    }

                    if (JSON.parse(e._body).message != null) {
                        this.showError('app.notification.ERROR', JSON.parse(e._body).message, interpolateParams);
                        return;
                    }
                }

                this.showError('app.notification.ERROR', 'app.notification.UNEXPECTED_ERROR');
                break;
        }
    }

    private getTranslation(key: string, interpolateParams?: any) {
        let _result = '';
        this.translateService.get(key, interpolateParams).subscribe((res: string) => { _result = res; });
        return _result;
    }
}


// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./~/angular2-template-loader!./~/source-map-loader!./~/tslint-loader!./angularApp/app/shared/services/notification.service.ts